import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { classNameTriskeleParser } from '../../utilities/customStyles';
import MasterAccess from '../../dataAccess/MasterAccess';

const defaultPaths = {
  analytics: '/home/analytics',
  recommendations: '/home/recommendations',
  dashboard: '/home/dashboard',
};

const CategoriesHeader = (props) => {
  const [categories, setCategories] = useState([]);
  const [activeTab, setActiveTab] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();
  const { clientId} = props;
  // classes
  const textSelectedTriskeleClass = classNameTriskeleParser('Tab', 'Enabled', 'Text', 'Selected');
  const textUnSelectedTriskeleClass = classNameTriskeleParser('Tab', 'Enabled', 'Text', 'Unselected');
  const lineSelectedTriskeleClass = classNameTriskeleParser('Tab', 'Enabled', 'Line', 'Selected');
  const lineUnSelectedTriskeleClass = classNameTriskeleParser('Tab', 'Enabled', 'Line', 'Unselected');

  const getAppFeatureTabs = () => {
    MasterAccess.getAppFeatures()
      .then((response) => {
        const sortedData = response.data.sort((a, b) => a.AppFeatureSortOrdr - b.AppFeatureSortOrdr);

        if (sortedData.length && sortedData[0].AppFeatureName) {
          setActiveTab(sortedData[0].AppFeatureName.toLowerCase());
        }

        setCategories(sortedData);
      })
      .catch(() => {
        navigate('/maintenance', { replace: true });
      });
  };

  useEffect(() => {
    getAppFeatureTabs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Update activeTab when location changes
  useEffect(() => {
    const currentPath = location.pathname.toLowerCase();

    if (currentPath.includes('analytics')) setActiveTab('analytics');
    else if (currentPath.includes('recommendations')) setActiveTab('recommendations');
    else if (currentPath.includes('dashboard') || currentPath.includes('clientlist')) setActiveTab('dashboard');
  }, [location.pathname]);

  // ✅ Attach scroll listener safely + cleanup
  // useEffect(() => {
  //   const scrollContainer = document.getElementById('scrollContainer');
  //   if (!scrollContainer) return;

  //   const onScroll = (e) => {
  //     const scrollSize = e.currentTarget.scrollTop;
  //     const categoriesHeader = document.getElementById('categories-header');
  //     const profileHeaderBox = document.getElementById('profile-header-box');

  //     if (!categoriesHeader || !profileHeaderBox) return;

  //     if (scrollSize > 20) {
  //       categoriesHeader.style.margin = '10px 0px 5px';
  //       profileHeaderBox.style.padding = '5px 20px';
  //     } else {
  //       categoriesHeader.style.margin = '25px 0px 5px';
  //       profileHeaderBox.style.padding = '10px 20px';
  //     }
  //   };

  //   scrollContainer.addEventListener('scroll', onScroll);
  //   return () => scrollContainer.removeEventListener('scroll', onScroll);
  // }, []);

  const openTab = (tabName) => {
    const tabKey = (tabName || '').toLowerCase();
    let targetPath = defaultPaths[tabKey] ?? defaultPaths.dashboard;
    targetPath += `?clientid=${clientId}`;
    if (location.pathname === targetPath) return;

    setActiveTab(tabKey);
    navigate(targetPath);
  };

  let currentLocation = location.pathname.split('/').pop();
  if (currentLocation === 'home') currentLocation = 'dashboard';
  if (currentLocation === 'add') currentLocation = 'recommendations';
  if (currentLocation === 'chart') currentLocation = 'analytics';

  return (
    <div id="categories-header" className="categories-header">
      {categories &&
        categories.map((ctg) => {
          const tabKey = ctg.AppFeatureName.toLowerCase();
          const isActive = activeTab === tabKey;

          return (
            <span
              onClick={() => openTab(ctg.AppFeatureName)}
              key={ctg.AppFeatureName}
              className={`categories-header-main-item ${
                isActive ? textSelectedTriskeleClass : textUnSelectedTriskeleClass
              }`}
              aria-hidden="true"
            >
              <div className="categories-header-main-item">{ctg.AppFeatureName}</div>

              {currentLocation.includes(tabKey) && (
                <div
                  className={`categories-header-main-item-line ${
                    isActive ? lineSelectedTriskeleClass : lineUnSelectedTriskeleClass
                  }`}
                />
              )}
            </span>
          );
        })}
    </div>
  );
};

export default CategoriesHeader;
